import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'shared/config/routes'
import { curriculumStore } from 'shared/stores/curriculumStore'
import { ensureCurriculumLoaded } from 'shared/stores/ensureCurriculumLoaded'
import { ensureStudentsLoaded } from 'pages/Students/model/ensureStudentsLoaded'

export default function useCurriculumSection() {
	const navigate = useNavigate()

	useEffect(() => {
		Promise.all([ensureCurriculumLoaded(), ensureStudentsLoaded()]).catch(
			error => {
				console.error('Failed to load curriculum:', error)
			},
		)
	}, [])

	const cards = curriculumStore.dashboardGradeCards

	const handleViewAllSessions = useCallback(gradeTab => {
		navigate(ROUTES.CLASSROOM, {
			state: {
				viewMode: 'curriculum',
				gradeTab,
			},
		})
	}, [navigate])

	const handleResourceClick = useCallback((session, resourceKey) => {
		curriculumStore.handleResourceClick(session, resourceKey)
	}, [])

	const handleTaskClick = useCallback((session, grade) => {
		if (!session || grade == null) return

		const button = curriculumStore.getAssignmentButtonState(session, grade)
		const gradeTab = `grade_${grade}`

		if (button.case === 'none') {
			navigate(ROUTES.CLASSROOM, {
				state: {
					gradeTab,
					openCreateModal: {
						grade,
						assignmentType: session.assignmentType || '',
						title: session.title || '',
					},
				},
			})
			return
		}

		if (button.case === 'single' && button.taskId != null) {
			navigate(ROUTES.CLASSROOM, {
				state: {
					gradeTab,
					openAssignmentId: button.taskId,
				},
			})
			return
		}

		navigate(ROUTES.CLASSROOM, {
			state: {
				gradeTab,
				viewMode: 'table',
				assignmentTypeFilter: session.assignmentType || '',
			},
		})
	}, [navigate])

	const handleMarkComplete = useCallback(async (session, grade) => {
		if (!session?.id || grade == null || session.completed) return

		try {
			await curriculumStore.markSessionComplete({
				grade,
				sessionId: session.id,
			})
		} catch (error) {
			console.error('Failed to mark session complete:', error)
		}
	}, [])

	return {
		cards,
		handleViewAllSessions,
		handleResourceClick,
		handleTaskClick,
		handleMarkComplete,
	}
}
